export default __webpack_public_path__ + "static/pemba-island-bff4d236b0d32e7c187529872b953ee1.jpg";